import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { ProductNumberList } from "./ProductNumberList";
import ProductNumberCreate from "./ProductNumberCreate";
import ProductNumberAssign from "./ProductNumberAssign";
import { ProductNumberBlockRange } from "./ProductNumberBlockRange";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function ProductNumbers() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(ProductNumberCreate, null))); } }),
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/assign/:productId"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(ProductNumberAssign, null))); } }),
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/block-range"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(ProductNumberBlockRange, null))); } }),
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                ] },
                React.createElement(ProductNumberList, null))); } })));
}
export default ProductNumbers;
